<template>
  <transition appear name="van-fade" mode="out-in">
    <div class="main" v-if="initOver">
      <div class="header">
        <img
          src="https://vmsres.dianzhenkeji.com/0/hnr/2021/4/19/1383987196134055936.jpg"
          alt=""
        />
        <a href="http://www.hnr.cn?fm=1" class="header_text">电脑版</a>
      </div>

      <van-tabs
        ref="tabs"
        v-model:active="active"
        :swipeable="is_mobile"
        sticky
        @scroll="handleTabsScroll"
      >
        <van-tab class="custom_tab" :title="first_title">
          <FirstPage :index="0"></FirstPage>
        </van-tab>
        <van-tab
          v-for="(item, index) in tags"
          :key="item.id"
          class="custom_tab"
        >
          <template #title>
            <span
              v-show="!item.tags_img"
              :class="{ tags_with_img: item.tags_img ?? false }"
              >{{ item.tags_name }}</span
            >
            <van-image
              v-if="item.tags_img"
              width="60px"
              height="30px"
              fit="contain"
              :src="item.tags_img"
              class="tags_img"
            />
          </template>
          <!-- 首先先判断是否是活跃标签,如果是活跃标签的话，才会加载这个插件 -->
          <CommonList :index="index + 1" :tagsInfo="item"></CommonList>
        </van-tab>
      </van-tabs>
      <transition name="van-slide-right">
        <div class="floatBox" id="floatBox" v-show="topShow">
          <div @click="handleTop">
            <img
              src="data:image/png;base64,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"
              alt="top"
            />
          </div>
        </div>
      </transition>
    </div>
    <Init v-else></Init>
  </transition>
</template>

<script>
import {
  ref,
  onMounted,
  computed,
  watch,
  provide,
  readonly,
  watchEffect,
} from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";

import CommonList from "./CommonList";
import FirstPage from "./FirstPage";
import mobile from "is-mobile";

import Init from "./Init";

export default {
  name: "Main",
  components: {
    CommonList,
    FirstPage,
    Init,
  },
  props: {},
  setup() {
    // 初始化tab,默认为0
    const active = ref(0);
    // 并且把活动标签提供出去
    provide("active", readonly(active));

    const is_mobile = ref(mobile());
    // 将响应式
    const scrollTop = ref(0);

    provide("scrollTop", readonly(scrollTop));

    // 处理滚动事件
    onMounted(() => {
      window.addEventListener(
        "scroll",
        () => {
          scrollTop.value = document.documentElement.scrollTop
            ? document.documentElement.scrollTop
            : document.body.scrollTop;
        },
        { passive: true }
      );
    });

    const topShow = computed(() => {
      return scrollTop.value > 200 ? true : false;
    });

    const handleTop = () => {
      document.documentElement.scrollTop = document.body.scrollTop = 0;
    };

    // vuex
    const store = useStore();
    const tags = computed(() => {
      return store.state.tags;
    });

    // 处理路由
    const router = useRouter();
    const route = useRoute();

    // 检测tags的变化,tags变化说明加载完毕
    // TODO:是否改成事件通知更好一些？
    watchEffect(() => {
      const index = +route.params.activeIndex;
      console.log("tags", index);
      // 如果不是0 tags数组有效 索引在数组有效范围内
      if (
        index != 0 &&
        tags.value.length != 0 &&
        tags.value.length - 1 >= index
      ) {
        active.value = +route.params.activeIndex;
      }
    });
    // 监听active变化,并且加入历史数组
    watch(active, () => {
      router.replace({
        name: "main",
        params: {
          activeIndex: active.value,
        },
      });
    });

    const is_fixed = ref(false);
    const tabs = ref(null);
    // 观察tabs scroll如果fixed的话，就重绘一次解决位置不固定的问题
    const handleTabsScroll = (e) => {
      is_fixed.value = e.isFixed;
    };
    watch(is_fixed, () => {
      tabs.value.resize();
    });

    // 处理首页标题
    const first_title = ref("推荐");
    // 修改首页标题
    const updateFirstTitle = (title) => {
      first_title.value = title;
       tabs.value.resize();
    };
    provide("updateFirstTitle", updateFirstTitle);

    return {
      active,
      tags,
      is_mobile,
      scrollTop,
      topShow,
      handleTop,
      initOver: computed(() => store.state.initOver),
      handleTabsScroll,
      tabs,
      first_title,
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
body {
  font-size: 14px;
}
.header {
  height: 1.4rem;
  background-color: #b91b25;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header img {
  height: 80%;
  margin-left: 0.333333rem;
}

.header_text {
  margin-left: 15px;
  color: #fff;
  font-size: 0.36rem;
  margin-right: 0.4rem;
}

.main .van-tabs--line .van-tabs__wrap {
  line-height: 50px;
  height: 50px;
}

.main .van-sticky--fixed .van-tabs__nav {
  background-color: #af1d28;
}
.main .van-sticky--fixed .van-tabs__nav .van-tab {
  color: #ffffff;
}
.main .van-sticky--fixed .van-tabs__line {
  background-color: #ffffff;
}

.main .van-tab--active {
  font-weight: bold;
}
.main .van-tab {
  font-size: 16px;
}

.main .van-tabs__line {
  height: 5px;
}

.van-tabs__nav {
  background-color: #f3f4f5;
}

.van-tab {
  color: #505050;
}

.common_item_bigimg {
  margin-bottom: 5px;
}

.floatBox {
  position: fixed;
  bottom: 26px;
  right: 22px;
  text-align: center;
  z-index: 997;
}
.floatBox img {
  width: 50px;
}

.van-tab__text .van-image {
  padding-top: 5px;
}

.van-sticky--fixed .van-tab__text .tags_with_img {
  display: inline !important;
}
.van-sticky--fixed .van-tab__text .tags_img {
  display: none !important;
}
</style>
